import { ANONYMOUS_CLIENT_DISPLAY_NAME } from '@ametista-ai/api-schema';
import type { TFunction } from 'i18next';

/** Swap the server's language-agnostic placeholder names for translated labels. */
export function localizeDisplayName<T extends string | null | undefined>(
  displayName: T,
  t: TFunction
): T | string {
  if (displayName === ANONYMOUS_CLIENT_DISPLAY_NAME) {
    return t('users.anonymous-client');
  }
  return displayName;
}
